@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
@if(basic_source_error) {
  <div class="alert alert-warning">This report is sourced from real time data, and historic data cannot be sent.</div>
}
@if(confirm_needed) {
  <div class="alert alert-info">
    <p>You are about to request backfill data. Are you sure?</p>
    <button class="btn btn-primary" (click)="confirm()">Confirm</button>
    <button class="btn btn-default" (click)="cancel()">Cancel</button>
  </div>
}
@if(isLoading) {
  <app-loader
    message="Loading...">
  </app-loader>
} @else {
  <div class="container">
    <div class="row">
      <div class="span9">
        <h1> Send Backfill Report</h1>
      </div>
      <p class="lead">
        Resend interval data to VTN for past date ranges.
    </div>
    <form name="requestForm" class="form-horizontal" [formGroup]="requestForm">
      <div class="form-group">
        <label for="report"> Registered report (format: [ven_id] : [report_id] : [granularity]) </label>
        <select id="report" class="form-control" name="registered_reports.id" type="select" (change)="setRegisteredReports($event.target)" required >
          <option value selected disabled></option>
          @for(registered_reports of report; track report) {
            <option [value]="registered_reports.id">{{registered_reports?.ven?.ven_id}} : {{registered_reports?.id}} : {{registered_reports?.granularity}}</option>
          }
        </select>
      </div>

      <div class="form-group">
        <label for="streamed"> Streamed: </label>
        <br/>
        <small>If set, historic data will be sent in small chunks, like it would have been streamed originally.</small>
        <br/>
        <small>If not set, historic data will be sent in as few reports as possible.</small>
        <br/>
        <input id="streamed" class="form-check-input" name="reportResult.streamed" type="checkbox" (change)="setStreamed($event.target)" [checked]="reportSelected?.metadata_report?.data_source && reportSelected?.metadata_report?.data_source!=='enbala'">
      </div>

      <div class="form-group">
        <label for="rids"> RIDs (defaults to using all if none selected): </label>
        <select id="rids" class="form-control" name="rid.id" type="select" (change)="setRid($event.target)" required multiple >
          @for(rid of rids; track rid) {
            <option [value]="rid.id">{{rid.id}}</option>
          }
        </select>

      </div>

      <div class="form-group">
        <label for="start_dttm"> Start time: </label>
        <input id="start_dttm" name="startTime" class="form-control" placeholder="2017-01-11T18:00:00Z" type="text" formControlName="startTime" required>
        @if(requestForm.get('startTime')?.invalid && (requestForm.get('startTime')?.dirty || requestForm.get('startTime')?.touched)) {
          <div class="text-danger">
            <div *ngIf="requestForm.get('startTime')?.errors?.['required']">Start time is required.</div>
            <div *ngIf="requestForm.get('startTime')?.errors?.['pattern']">Must be a valid ISO timestamp (e.g., 2017-01-11T18:00:00Z).</div>
          </div>
        }
      </div>

      <div class="form-group">
        <label for="end_dttm"> End time: </label>
        <input id="end_dttm" name="endTime" class="form-control" placeholder="2017-01-11T19:00:00Z" type="text" formControlName="endTime" required>
        @if(requestForm.get('endTime')?.invalid && (requestForm.get('endTime')?.dirty || requestForm.get('endTime')?.touched)) {
          <div class="text-danger">
            <div *ngIf="requestForm.get('endTime')?.errors?.['required']">End time is required.</div>
            <div *ngIf="requestForm.get('endTime')?.errors?.['pattern']">Must be a valid ISO timestamp (e.g., 2017-01-11T19:00:00Z).</div>
          </div>
        }
      </div>

      <button id="performAction" class="btn btn-primary" type="button" (click)="performReport()" [disabled]="basic_source_error">Perform report</button>
    </form>
    <h3> Request Results</h3>
    <div class="container-fluid">
      <div class="row"> <label> Status: </label> {{status}}</div>
      <div class="row"> <label> Request made at: </label> {{result.request_dttm}} </div>
      <div class="row"> <label> Start time: </label> {{result.start_dttm}} </div>
      <div class="row"> <label> End time: </label> {{result.end_dttm}} </div>
      <div class="row"> <label> Number of RIDs: </label> {{result.num_rids}} </div>
      <div class="row"> <label> Number of interval dttms: </label> {{result.num_interval_dttms}} </div>
      <div class="row"> <label> Number of intervals expected: </label> {{result.expected}} </div>
      <div class="row"> <label> Number of intervals available: </label> {{result.available}} </div>
      <div class="row"> <label> Number of intervals missing: </label> {{result.missing}} </div>
      <div class="row"> <label> Number of intervals sent successfully: </label> {{result.succeeded}} </div>
      <div class="row"> <label> Splunk query: </label>
        @if(result.report_id) {
          <div> "Backfill report completed. report_id={{result.report_id}}"</div>
        }
      </div>
    </div>
  </div>
}
